import React, { useEffect, useState } from 'react';
import Chart from 'react-apexcharts';
// import data from '../data.json';

const DualBarChart = () => {
  const [chartData, setChartData] = useState([]);

  useEffect(() => {
    // Merge Footfall and Customer-Staff Interaction Data
    // const mergedData = data.footfall.zoneFootfall.map((zone) => {
    //   const interaction = data['customer-staff-customer-product'].find((item) => item.zone_name === zone.zone_name);
    //   return {
    //     zone_name: zone.zone_name,
    //     footfall: zone.footfall,
    //     customerStaff: interaction ? interaction.customerStaff : 0
    //   };
    // });

    // setChartData(mergedData);
    setChartData([]);
  }, []);

  const options = {
    chart: {
      type: 'bar',
      toolbar: { show: false }
    },
    xaxis: {
      categories: chartData.map((item) => item.zone_name),
      title: {
        text: 'Zones' // X-Axis Title
      }
    },
    plotOptions: {
      bar: {
        horizontal: false,
        borderRadius: 7,
        borderRadiusApplication: 'end',
        columnWidth: '55%',
        barGap: 10
      }
    },
    stroke: {
      show: true,
      width: 6,
      colors: ['transparent']
    },
    dataLabels: { enabled: false },
    legend: { position: 'top' },
    colors: ['#A8E4B1', '#44BE54'],
    yaxis: {
      title: { text: 'Count (Footfall & Interactions)' } // Y-Axis Title
    }
  };

  const series = [
    {
      name: 'Footfall',
      data: chartData.map((item) => item.footfall)
    },
    {
      name: 'Customer-Staff Interaction',
      data: chartData.map((item) => item.customerStaff)
    }
  ];

  return (
    <div style={{ position: 'relative', width: '100%', height: '400px' }}>
      <Chart options={options} series={series} type="bar" height={400} />
    </div>
  );
};

export default DualBarChart;
